import { render, staticRenderFns } from "./statisticsData.vue?vue&type=template&id=4b3ddd6a&scoped=true&"
import script from "./statisticsData.vue?vue&type=script&lang=js&"
export * from "./statisticsData.vue?vue&type=script&lang=js&"
import style0 from "./statisticsData.vue?vue&type=style&index=0&id=4b3ddd6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3ddd6a",
  null
  
)

export default component.exports